// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyAGNk-G9AzfgIfW2mCz6SxeF-bE3-ZMrP0",
    authDomain: "kairali-45b1d.firebaseapp.com",
    databaseURL: "https://kairali-45b1d.firebaseio.com",
    projectId: "kairali-45b1d",
    storageBucket: "kairali-45b1d.appspot.com",
    messagingSenderId: "316757918624",
    appId: "1:316757918624:web:4e635dd7f7757302d1dac5",
    measurementId: "G-4TM6D0MQWM"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
